var _rect, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKatalchain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 131,
    height: 131,
    x: 0,
    y: 0,
    stroke: "currentColor",
    strokeWidth: 10,
    fill: "transparent"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 131,
    height: 40,
    x: 0,
    y: 45,
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKatalchain);
export default __webpack_public_path__ + "static/media/katalchain.ffcda532342a1d4743e096cf246b0556.svg";
export { ForwardRef as ReactComponent };